module.exports = __webpack_public_path__ + "static/media/table_sort_icon.85acc5f7.svg";